<template>
  <div class="gifPreview">
    <heading type="h1">GIF Preview</heading>
  </div>
</template>

<script>
import Heading from '@/components/Heading/heading'

export default {
  name: 'gifPreview',
  components: {
    Heading
  }
}
</script>

<style lang="scss">
    .gifPreview {
        padding-top: 40px;
        text-align: center;
        width:100%;
        height:100%;
        background-color: yellow;
        position: absolute;
        top:0;
        left:0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dev/gif-preview.vue